import React, { Component } from 'react';
import { Modal, Steps, Button, message, Select, DatePicker, TimePicker } from 'antd';
import axios from 'axios';
import Configuration from '../../Configuration';
import moment from 'moment';
const Step = Steps.Step;
const Option = Select.Option;

class VisitServiceModal extends Component {
  constructor(props) {
    super(props);
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.steps = {step0: {service_id: false, transport_id: false}, step1: {due_date: false, time: false}, step2: {details: true}};
    this.state = {step: 0, stepLimit: 2, stepValidation: this.steps, visitService: {}, services: [], transports: []};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    this.getServices = this.getServices.bind(this);
    this.getTransports = this.getTransports.bind(this);
    // Input values
    this.handleName = this.handleName.bind(this);
    this.handleServices = this.handleServices.bind(this);
    this.handleTransports = this.handleTransports.bind(this);
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleTime = this.handleTime.bind(this);
    this.handleDetails = this.handleDetails.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  componentDidMount() {
    this.getServices();
    this.getTransports();
  }

  handleNext() {
    if(!this.validateStep())
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.visitService);
      this.setState({visitService: {}, step: 0, stepValidation: this.steps});
    } else {
      let steps = 1;
      // Autocomplete date inputs
      if(this.state.step === 0 && this.props.hideDate) {
        this.handleDueDate(moment());
        this.handleTime(moment());
        steps = 2;
      }

      this.setState({step: this.state.step + steps});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose('serviceVisible');
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  validateStep() {
    let steps = 0;
    let total = 0;
    for(let item in this.state.stepValidation[`step${this.state.step}`]) {
      if(this.state.stepValidation[`step${this.state.step}`][item]) {
        steps += 1;
      }
      total += 1;
    }
    
    if(steps === total) {
      return true;
    } else {
      return false;
    }
  }

  getServices() {
    axios.get(`${Configuration.apiServer}/api/v1/services`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({services: resp.data});
    });
  }

  getTransports() {
    axios.get(`${Configuration.apiServer}/api/v1/transports`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({transports: resp.data});
    });
  }

  handleName(event) {
    this.setProp('name', event.target.value);
  }

  handleServices(value) {
    const service = value.split('-');
    this.setProp('service_id', service[0]);
    this.setProp('service_name', service[1]);
  }
  
  handleTransports(value) {
    this.setProp('transport_id', value);
  }

  handleDueDate(value) {
    this.setProp('due_date', value.format('YYYY-MM-DD'));
  }

  handleTime(value) {
    this.setProp('time', value.format('HH:mm:ss'));
  }

  handleDetails(event) {
    this.setProp('details', event.target.value);
  }

  setProp(prop, value) {
    const record = this.state.visitService;
    let validation = this.state.stepValidation;
    record[prop] = value;
    
    // Update validation
    if(String(value).length > 0) {
      validation[`step${this.state.step}`][prop] = true;
    } else {
      validation[`step${this.state.step}`][prop] = false;
    }

    this.setState({visitService: record, stepValidation: validation});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // Options for services select
    const serviceOptions = this.state.services.map(service => {
      return (
        <Option value={`${service.id}-${service.name}`} className="text-capitalize" key={`service:${service.id}`}>{service.name}</Option>
      );
    });
    // Options for transports select
    const transportOptions = this.state.transports.map(transport => {
      return (
        <Option value={transport.id} className="text-capitalize" key={`transport:${transport.id}`}>{transport.name}</Option>
      );
    });

    // Render component
    return (
      <Modal
        title="Visita de servicio"
        visible={this.props.visible}
        onCancel={() => { this.props.handleClose('serviceVisible') }}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Tipo de servicio" />
            <Step title="Fecha" />
            <Step title="Detalles" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Tipo de servicio</label>
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="Elige un servicio"
                optionFilterProp="children"
                onChange={this.handleServices}
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {serviceOptions}
              </Select>
            </div>

            <div className="form-group">
              <label>Tipo de transporte</label>
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="Elige un transporte"
                optionFilterProp="children"
                onChange={this.handleTransports}
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {transportOptions}
              </Select>
            </div>
          </div>
          
          <div style={{ width: '100%', display: this.showStep(1) }}>
            <div className="form-group">
              <label>¿Qué día es la visita?</label>
              <br />
              <DatePicker onChange={this.handleDueDate} style={{ width: '100%' }} />
            </div>
            <div className="form-group">
              <label>¿A qué hora llega la visita?</label>
              <br />
              <TimePicker onChange={this.handleTime} style={{ width: '100%' }}  />
            </div>
          </div>

          <div style={{ width: '100%', display: this.showStep(2) }}>
            <div className="form-group">
              <label>Detalles (Opcional)</label>
              <input type="text" className="form-control" placeholder="Escribe algunos detalles sobre la visita" onChange={this.handleDetails} />
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default VisitServiceModal;



// WEBPACK FOOTER //
// ./src/components/modals/VisitServiceModal.js